export default __webpack_public_path__ + "static/media/zertiassist_iconos_page_24px.2e9ecd8e.svg";